import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { vendorInvoiceAPI } from "../../../helpers/api/vendorInvoice";

export default function useInvoiceActions({ onRefresh }) {
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showEditModal,   setShowEditModal]   = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting,      setIsDeleting]      = useState(false);

  const openAdd = useCallback(() => {
    setSelectedInvoice(null);
    setShowEditModal(true);
  }, []);

  const openEdit = useCallback((invoice) => {
    setSelectedInvoice(invoice);
    setShowEditModal(true);
  }, []);

  const closeEdit = useCallback(() => {
    setShowEditModal(false);
    setSelectedInvoice(null);
  }, []);

  const openDelete = useCallback((invoice) => {
    setSelectedInvoice(invoice);
    setShowDeleteModal(true);
  }, []);

  const cancelDelete = useCallback(() => {
    setShowDeleteModal(false);
    setSelectedInvoice(null);
  }, []);

  const confirmDelete = useCallback(async () => {
    if (!selectedInvoice || isDeleting) return;
    setIsDeleting(true);
    try {
      await vendorInvoiceAPI.delete(selectedInvoice.id);
      toast.success("Invoice deleted");
      setShowDeleteModal(false);
      setSelectedInvoice(null);
      onRefresh();
    } catch {
      toast.error("Failed to delete invoice");
    } finally {
      setIsDeleting(false);
    }
  }, [selectedInvoice, isDeleting, onRefresh]);

  return {
    selectedInvoice,
    editModal:   { open: showEditModal,   invoice: selectedInvoice, onClose: closeEdit },
    deleteModal: { show: showDeleteModal, onConfirm: confirmDelete, onCancel: cancelDelete },
    isDeleting,
    openAdd,
    openEdit,
    openDelete,
  };
}
